var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { mapGetters } from 'vuex';
import Component from 'vue-class-component';
import { Loading } from 'element-ui';
import EHandleStatus, { EHanldeStatus } from '../../enum/EHandleStatus';
import { auth } from "../../helper/authDecorator";
import { UrlHelper } from '../../helper/UrlWrapper';
import { nameDict } from "../../constant/authCode";
import GLOBAL_VUE from '../../globalVue';
import QuotedPrice from '../../api/QuotedPrice';
import WarehouseService from '../../api/WarehouseService';
import AddDialog from "./components/GoodAdd.vue";
import Header from "./components/AddHeader.vue";
import RequiredMixin from "../../components/renderHeader/RequiredMixin";
import ArtMsglist from "../../components/alert/ArtMsglist.vue";
export var ESaveType;
(function (ESaveType) {
    ESaveType[ESaveType["SAVE"] = 1] = "SAVE";
    ESaveType[ESaveType["SAVE_PRINT"] = 2] = "SAVE_PRINT";
})(ESaveType || (ESaveType = {}));
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tableHeight = document.documentElement.clientHeight - 280;
        _this.data = [];
        _this.formData = {
            organ_id: '',
            depot_id: '',
            out_organ_id: '',
            out_depot_id: '',
            order_icomment: ''
        };
        _this.enumStatus = EHandleStatus;
        _this.handleStatus = EHandleStatus.Add;
        _this.ESaveType = ESaveType;
        _this.from_system = 3;
        _this.orderid = '';
        _this.total = 0;
        _this.start = 0;
        _this.limit = 20;
        _this.dialogTableVisible = false;
        _this.dialogTableEditVisible = false;
        _this.importSuccessNum = 0;
        _this.importFailnum = 0;
        _this.befordImport = true;
        _this.importting = false;
        _this.afterImport = false;
        _this.failDownLoadUrl = "";
        _this.responseSuccess = false;
        _this.responseFail = false;
        _this.errorMsg = "";
        _this.emptyMoneyCanSubmit = false;
        _this.notAllEmptyFlag = true;
        _this.emptyFlag = true;
        _this.goods_format_ids = [];
        return _this;
    }
    default_1.prototype.selectionChange = function (rows) {
        this.selections = rows;
    };
    default_1.prototype.created = function () {
        this.service = QuotedPrice.getInstance();
        this.warehouseService = WarehouseService.getInstance();
        if (this.orderid) {
            this.getDetail();
        }
    };
    default_1.prototype.mounted = function () {
    };
    default_1.prototype.getDetail = function () {
        var _this = this;
        this.handleStatus = EHandleStatus.Edit;
        var loadingInstance = Loading.service({ fullscreen: true });
        var params = {
            order_id: this.orderid,
            edit: 1
        };
        this.warehouseService.getDetail(params).then(function (res) {
            loadingInstance.close();
            var data = res.data.data;
            _this.data = data.order_detail;
            _this.total = res.data.total || 0;
            var goods_format_ids = (data.detail || []).map(function (good) {
                return good.goods_format_id;
            });
            _this.goods_format_ids = goods_format_ids || [];
            _this.formData = Object.assign({}, _this.formData, {
                depot_id: data.depot_id,
                organ_name: data.organ_name,
                depot_name: data.depot_name,
                warehouse_date: data.warehouse_date,
                supplier_upper_name: data.supplier_upper_name,
                purchasing_agent: data.purchasing_agent,
                order_icomment: data.order_icomment,
                organ_id: data.organ_id,
                out_depot_id: data.out_depot_id,
                out_depot_name: data.out_depot_name,
                order_code: data.order_code,
                out_organ_id: data.out_organ_id,
                out_organ_name: data.out_organ_name,
            });
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message || err.msg);
        });
    };
    default_1.prototype.save = function (saveType) {
        var _this = this;
        var formData = this.formData;
        if (!this.data || !this.data.length) {
            this.$message.warning("请添加货品");
            return;
        }
        var flag = false;
        this.data.forEach(function (row) {
            if (row.transfer_stock == undefined || row.transfer_stock == '' || row.transfer_stock <= 0) {
                flag = true;
            }
        });
        if (flag) {
            this.$message.warning('调拨数量不可为空，且必须大于0');
            return;
        }
        if (this.handleStatus === EHanldeStatus.Add) {
            var data = this.data.map(function (item) {
                return {
                    goods_id: item.goods_id || '',
                    goods_format_id: item.goods_format_id || '',
                    transfer_stock: item.transfer_stock || '',
                    order_detail_icomment: item.order_detail_icomment || ''
                };
            });
            var params_1 = __assign({}, formData, { order_detail: JSON.stringify(data) });
            this.warehouseService.addUpperwarehouse(params_1).then(function (res) {
                _this.afterSave(res, params_1, saveType);
            }, function (err) {
                _this.$message.error(err.message);
            }).catch(function (err) {
                _this.$message.error(err.message);
            });
        }
        else {
            var data = this.data.map(function (item) {
                return {
                    goods_id: item.goods_id || '',
                    goods_format_id: item.goods_format_id || '',
                    transfer_stock: item.transfer_stock || '',
                    order_detail_icomment: item.order_detail_icomment || ''
                };
            });
            var params_2 = __assign({}, formData, { order_id: this.orderid, order_detail: JSON.stringify(data) });
            this.warehouseService.addUpperwarehouse(params_2).then(function (res) {
                _this.afterSave(res, params_2, saveType);
            }, function (err) {
                _this.$message.error(err.message);
            }).catch(function (err) {
                _this.$message.error(err.message);
            });
        }
    };
    default_1.prototype.afterSave = function (res, params, saveType) {
        var _this = this;
        if (res.data.success) {
            if (res.data.code == 73) {
                var instance = this.$dialog(ArtMsglist, {
                    data: {
                        msgData: res.data.data
                    }
                }, {
                    title: "提示",
                    width: 450,
                    height: 350,
                    closeBtn: false,
                }).instance;
                instance.$on("artMsglist:ok", function (data) {
                    params.confirm = res.data.data[0].confirm;
                    _this.warehouseService.addUpperwarehouse(params).then(function (res) {
                        if (res.data.success) {
                            _this.$message.success("保存成功");
                            if (saveType == ESaveType.SAVE_PRINT) {
                                _this.mulPrint();
                            }
                            setTimeout(function () {
                                GLOBAL_VUE.$emit("closeTab", _this);
                                if (_this.opener) {
                                    _this.opener.getList();
                                }
                            }, 500);
                        }
                    });
                });
            }
            else {
                this.$message.success("保存成功");
                if (saveType == ESaveType.SAVE_PRINT) {
                    this.mulPrint();
                }
                setTimeout(function () {
                    GLOBAL_VUE.$emit("closeTab", _this);
                    if (_this.opener) {
                        _this.opener.getList();
                    }
                }, 500);
            }
        }
    };
    default_1.prototype.mulPrint = function () {
        var url = "./static/js/print/print2.html";
        url = UrlHelper.addParam(url, 'type', "purBack");
        url = UrlHelper.addParam(url, 'order_id', this.orderid);
        url = UrlHelper.addParam(url, 'token', this.user.token);
        UrlHelper.windowOpenIntercept(url);
    };
    default_1.prototype.orderChange = function () {
    };
    default_1.prototype.clientChange = function (formData) {
    };
    default_1.prototype.inputChange = function (row, key) {
        if (row[key]) {
            var value = row[key];
            if (value.indexOf('.') === 0) {
                value = '0' + value;
            }
            value = value.replace(/。/g, '.');
            value = value.replace(/[^\d.]/g, '');
            var dotIndex = value.indexOf('.');
            if (dotIndex !== -1) {
                var decimalPart = value.substring(dotIndex + 1).replace(/\./g, '');
                value = value.substring(0, dotIndex + 1) + decimalPart.substring(0, 4);
            }
            row[key] = value;
        }
    };
    default_1.prototype.toAdd = function () {
        var _this = this;
        if (this.handleStatus === EHanldeStatus.Add && !this.formData.out_depot_id) {
            this.$message.warning("请选择调出仓库");
            return;
        }
        var dialog = this.$dialog(AddDialog, {
            data: {
                addedDatas: this.data,
                purchasers: this.formData.clientArray,
                depot_id: this.formData.out_depot_id
            }
        }, {
            title: "添加货品",
            width: 900,
            height: 550
        });
        dialog.instance.$on("submit", function (res) {
            _this.data = res;
            _this.selections = [];
            if (_this.handleStatus === EHanldeStatus.Edit) {
            }
        });
    };
    default_1.prototype.deleteGood = function () {
        var _this = this;
        if (!this.selections || !this.selections.length) {
            this.$message.warning("请选择货品");
            return;
        }
        this.$confirm("请确认是否删除该货品", '提示').then(function (res) {
            _this.selections.forEach(function (item) {
                var index = _this.data.indexOf(item);
                _this.data.splice(index, 1);
            });
        }, function (err) { });
    };
    default_1.prototype.pageChange = function (pager) {
    };
    default_1.prototype.emptyGood = function () {
        this.data = [];
    };
    default_1 = __decorate([
        auth(nameDict["调拨"], true),
        Component({
            mixins: [RequiredMixin],
            components: {
                'add-header': Header
            },
            computed: __assign({}, mapGetters({
                "user": "user"
            }))
        })
    ], default_1);
    return default_1;
}(Vue));
export default default_1;
